import { useContext, useState, useEffect } from "react";
import "./restaurant-order.styles.scss";
import { options, handleClick } from "./restaurant-order.utils";
import { Outlet, useNavigate } from "react-router-dom";
import { OrderTypeContext } from "../../../contexts/orderType.context";
const RestaurantOrder = () => {
  const [values, setValues] = useState(options);
  const { setOrderTypeContext } = useContext(OrderTypeContext);
  const navigate = useNavigate();
  useEffect(() => {
    navigate("");
  }, []);
  const handleNavigate = (value) => {
    if (value === "CURRENT_ORDERS") {
      navigate("current");
    } else {
      navigate("");
    }
  };
  const toggleOrderType = (value) => {
    if (value === "TABLESIDE") {
      setOrderTypeContext("tableside");
    } else if (value === "TAKEAWAY") {
      setOrderTypeContext("takeaway");
    }
  };
  return (
    <div className="restaurant-order-container">
      {window.innerWidth > 1024 ? (
        <div className="restaurant-order-desktop">
          <div className="ro-landing-header">
            {Object.keys(values).map((index) => {
              const value = index.replace("_", " ");
              const classValue = "ro-landing-header-button " + values[index];
              return (
                <div
                  key={index}
                  className={classValue}
                  onClick={() => {
                    toggleOrderType(index);
                    handleClick(setValues, index);
                    handleNavigate(index);
                  }}
                >
                  {value}
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div className="restaurant-order-mobile">
          <div className="ro-landing-header">
            {Object.keys(values).map((index) => {
              const value = index.replace("_", " ");
              const classValue = "ro-landing-header-button " + values[index];
              return (
                <div
                  key={index}
                  className={classValue}
                  onClick={() => {
                    toggleOrderType(index);
                    handleClick(setValues, index);
                    handleNavigate(index);
                  }}
                >
                  {value}
                </div>
              );
            })}
          </div>
        </div>
      )}

      <div className="ro-order">
        <Outlet />
      </div>
    </div>
  );
};
export default RestaurantOrder;
